import { environment } from '../environments/environment';

export const APP_CONFIG = {
  stagingName: environment.stagingName,

  paymentUrls: {
    success: () =>
      `${environment.production
        ? 'https://business.luqta.io'
        : 'https://business-dev.luqta.io'}/payment/success`,

    reject: () =>
      `${environment.production
        ? 'https://business.luqta.io'
        : 'https://business-dev.luqta.io'}/payment/reject`
  },
};
